//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
let d=[[[0,"DataSource",1,0],[0,"DataSourceType",1,0]],[[["name","eCheckBoxStatus","valueNew"],"EditDataItem",{},3,0],[["eDataSourceType","dataSource"],"InitializeDataFromDataSource",{},2,0]],[]];
SPLM.Features.ShipDesign.ManufacturingStockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ManufacturingStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ManufacturingStockBuilder.StockDataSourceType = Object.freeze({
    "None" : "None", "CustomerDefault" : "CustomerDefault"});

SPLM.Features.ShipDesign.ManufacturingStockBuilder.CheckBoxStatus = Object.freeze({
    "Unchecked" : "Unchecked", "Checked" : "Checked", "Required" : "Required"});

SPLM.Features.ShipDesign.ManufacturingStockBuilder.ObjectType = Object.freeze({
    "None" : "None", "Edge" : "Edge", "Face" : "Face", "Body" : "Body", "Feature" : "Feature", "Part" : "Part", "Num" : "Num"});

SPLM.Features.ShipDesign.ManufacturingStockBuilder.LockedStatus = Object.freeze({
    "Unlocked" : "Unlocked", "Locked" : "Locked"});

export default SPLM;